const analysesThermostatsSearchColumns = {
  groupingId: {
    key: 'groupingId',
    label: 'grouping',
    type: 'text',
    sortable: 'custom',
    minWidth: 150,
  },
  labSampleCode: {
    key: 'labSampleCode',
    label: 'labSampleId',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  analysisCode: {
    key: 'analysisCode',
    label: 'analysisId',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  analysisDescription: {
    key: 'analysisDescription',
    label: 'analysisDescriptionFull',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  startedAt: {
    key: 'startedAt',
    label: 'startedAt',
    type: 'datetime',
    sortable: 'custom',
    minWidth: 150,
  },
  endedAt: {
    key: 'endedAt',
    label: 'endedAt',
    type: 'datetime',
    sortable: 'custom',
    minWidth: 150,
  },
  temperatureTrailId: {
    key: 'temperatureTrailId',
    label: 'temperatureTrailId',
    type: 'text',
    sortable: 'custom',
    minWidth: 150,
  },
  thermostatName: {
    key: 'thermostatName',
    label: 'thermostat',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
  temperature: {
    key: 'temperature',
    label: 'temperature',
    type: 'text',
    sortable: false,
    minWidth: 120,
  },
};

export default analysesThermostatsSearchColumns;
